import { SET_AUTOCONFIRMATION_ERROR, SET_AUTOCONFIRMATION_ORDER } from '../../actionTypes/acceptOrder'

export const setAutoConfirmationOrder = data => ({ type: SET_AUTOCONFIRMATION_ORDER, data })
export const setAutoConfirmationError = data => ({ type: SET_AUTOCONFIRMATION_ERROR, data })

